export default __webpack_public_path__ + "static/media/img-intro-banner-token.b2d5a057.png";